// removed by extract-text-webpack-plugin
module.exports = {"container":"SurveyNotFound__container___1r8FW","button":"SurveyNotFound__button___T0Vzk"};